import PropTypes, { Validator } from 'prop-types';
import tokens from '@lessonnine/design-tokens.lib/dist/json/variables.json';

// Rem
export type Rem = `${number}rem`;

const remRegex = /^{\d}+(\.{\d}+)?rem$/;
export const isRem = (value: unknown): value is Rem =>
  typeof value === 'string' && remRegex.test(value);

export const propTypeRem: Validator<Rem> = (props, propName, componentName) => {
  if (isRem(props[propName])) {
    return null;
  }
  return new Error(
    `Invalid prop ${propName} passed to ${componentName}. Expected a valid rem value.`
  );
};

// FontSizeToken
export type FontSizeToken = keyof typeof tokens.size.font;

export const isFontSizeToken = (value: unknown): value is FontSizeToken =>
  typeof value === 'string' && Object.keys(tokens.size.font).includes(value);

export const propTypeFontSizeToken = PropTypes.oneOf(
  Object.keys(tokens.size.font) as FontSizeToken[]
);

// FontSize
export type FontSize = number | FontSizeToken | Rem;

export const propTypeFontSize = PropTypes.oneOfType([
  PropTypes.number,
  propTypeRem,
  propTypeFontSizeToken,
]);
